import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  WritableSignal,
  signal,
} from '@angular/core';
import { AccordionItem } from '@shared/models/accordion-item';

@Component({
  standalone: false,
  selector: 'gstar-accordion-item',
  templateUrl: './accordion-item.component.html',
  styleUrls: ['./accordion-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionItemComponent implements OnInit {
  @Input() expanded!: boolean;
  @Input() hasError!: boolean;
  @Output() expandCollapse: EventEmitter<AccordionItem> = new EventEmitter();

  accordionItem: WritableSignal<AccordionItem> = signal(new AccordionItem());

  ngOnInit(): void {
    if (this.expanded) {
      const initializeItem = this.accordionItem();
      initializeItem.isExpanded = true;
      this.accordionItem.set(initializeItem);
    }
  }

  toggle(): void {
    const accordionItem = this.accordionItem();
    accordionItem.isExpanded = !accordionItem.isExpanded;
    this.expandCollapse.emit(accordionItem);
    this.accordionItem().changed.next(accordionItem.isExpanded);
  }
}
